<div class="ui-g-12">

  <div class="ui-g" *ngIf="data != null" style="margin: -40px 0 25px 10px;">
    <span style="font-weight: bold; margin-right: 10px">{{ 'customerBase.cluster' | translate }}:</span>{{ clustersString() }}
  </div>

  <div class="ui-g">
    <div *ngFor="let indicator of indicators" class="ui-g-12 ui-md-3 ui-sm-6">
      <app-infobox [pointData]="indicator.pointData" [t]="indicator.t" [penetration]="indicator.penetration" [options]="indicator.options"></app-infobox>
    </div>
  </div>

  <div class="campaigncharts" *ngIf="data != null">
    <div class="ui-g">
      <p-table [value]="datatable" class="overview-table" [paginator]="true" [rows]="10" [sortMode]="'multiple'">

        <ng-template pTemplate="header">
          <tr>
            <th [pSortableColumn]="'descrizione_categoria'">{{ translations.descrizione_categoria }} <p-sortIcon [field]="'descrizione_categoria'"></p-sortIcon></th>
            <th [pSortableColumn]="'revenues_sel'">{{ translations.revenues_sel }} <p-sortIcon [field]="'revenues_sel'"></p-sortIcon></th>
            <th [pSortableColumn]="'inc_sel_su_card'">{{ translations.inc_sel_su_card }} <p-sortIcon [field]="'inc_sel_su_card'"></p-sortIcon></th>
            <th [pSortableColumn]="'battuta_media_sel'">{{ translations.battuta_media_sel }} <p-sortIcon [field]="'battuta_media_sel'"></p-sortIcon></th>
            <th [pSortableColumn]="'battuta_media_card'">{{ translations.battuta_media_card }} <p-sortIcon [field]="'battuta_media_card'"></p-sortIcon></th>
            <th [pSortableColumn]="'delta_battuta_media'">{{ translations.delta_battuta_media }} <p-sortIcon [field]="'delta_battuta_media'"></p-sortIcon></th>
            <th [pSortableColumn]="'prc_speso_categ_selezionati'">{{ translations.prc_speso_categ_selezionati }} <p-sortIcon [field]="'prc_speso_categ_selezionati'"></p-sortIcon></th>
            <th [pSortableColumn]="'prc_speso_categ_cardisti'">{{ translations.prc_speso_categ_cardisti }} <p-sortIcon [field]="'prc_speso_categ_cardisti'"></p-sortIcon></th>
            <th [pSortableColumn]="'delta_prc_speso'">{{ translations.delta_prc_speso }} <p-sortIcon [field]="'delta_prc_speso'"></p-sortIcon></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-col>
          <tr>
            <td>{{ col.descrizione_categoria }}</td>
            <td class="number-column">{{ col.revenues_sel | formatNumber }}€</td>
            <td class="number-column">{{ col.inc_sel_su_card | formatNumber:1 }}%</td>
            <td class="number-column">{{ col.battuta_media_sel | formatNumber:1 }}€</td>
            <td class="number-column">{{ col.battuta_media_card | formatNumber:1 }}€</td>
            <td [class]="'number-column delta-row ' + (+col.delta_battuta_media < 0 ? 'delta-negative' : '')">{{ col.delta_battuta_media | formatNumber:2 }}%</td>
            <td class="number-column">{{ col.prc_speso_categ_selezionati | formatNumber:1 }}%</td>
            <td class="number-column">{{ col.prc_speso_categ_cardisti | formatNumber:1 }}%</td>
            <td [class]="'number-column delta-row ' + (+col.delta_prc_speso < 0 ? 'delta-negative' : '')">{{ col.delta_prc_speso | formatNumber:2 }}%</td>
          </tr>
        </ng-template>

      </p-table>
    </div>

  </div>
</div>







// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-value/customer-fair-share/customer-fair-share.component.html